import src from "IMAGE";
export default { src, width: 2192, height: 336, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AN/l6f/f5en/5urt/+vu8P/09fb/7/Hz/+ns7//o6+7/7F8eEOQGmqIAAAAASUVORK5CYII="};
